module.exports = __webpack_public_path__ + "img/MEA.afcc3955.png";